import { api } from "./api";

const SESSION_KEY = "shams_session_id";

export function getSessionId() {
  let s = localStorage.getItem(SESSION_KEY);
  if (!s) {
    s = (crypto.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(SESSION_KEY, s);
  }
  return s;
}

let queue = [];
let timer = null;

export function track(type, meta = {}, path) {
  try {
    queue.push({
      type,
      path: path || window.location.pathname,
      session_id: getSessionId(),
      meta,
    });
    if (!timer) timer = setTimeout(flush, 1500);
  } catch (e) {
    console.debug("analytics track skipped:", e);
  }
}

export function flush() {
  timer = null;
  const events = queue.splice(0);
  if (!events.length) return;
  api.post("/track", { events }).catch(() => {});
}

if (typeof document !== "undefined") {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState !== "hidden" || !queue.length) return;
    const events = queue.splice(0);
    try {
      const blob = new Blob([JSON.stringify({ events })], { type: "application/json" });
      navigator.sendBeacon(`${api.defaults.baseURL}/track`, blob);
    } catch (e) {
      console.debug("analytics beacon failed:", e);
    }
  });
}
